module.exports = __webpack_public_path__ + "img/snacks-link.8ca2e63c.svg";